import React, {
  useCallback, useRef, useState, useEffect,
} from 'react';
import moment from 'moment';
import { Row, Col, Button } from 'reactstrap';
import numeral from 'numeral';
import classnames from 'classnames';
import _ from 'lodash';
import { connect } from 'react-redux';

import { ConfirmationModal, Intl, TextField } from 'components';
import { currencyFormat, formatNumeral } from 'utils';

// const timeCampaignConstants = {
//   SIMULTANEUS_CALLS: parseInt( process.env.REACT_APP_SIMULTANEUS_CALLS, 10 ),
//   SUCCESS_RATE: 60,
//   DELAYS: 15,
// };

const timeCampaignConstants = {
  MAX_CHANNELS: parseInt( process.env.REACT_APP_SIMULTANEUS_CALLS, 10 ),
  CALL_INIT: 18,
  CALL_WRAP_UP: 5,
  OPTIONS_TIMEOUT: 5,
  OPTIONS_ATTEMPTS: 3,
  TOTAL_EXTRA_OPTIONS_TIME: 5 * 3,
}

// const getTime = ( values ) => {
//   const {
//     SIMULTANEUS_CALLS,
//     SUCCESS_RATE,
//     DELAYS,
//   } = timeCampaignConstants;

//   const numPhones = _.filter( values.contacts, { selected: true } ).length;

//   let messageDuration = 0;

//   if ( values.singleFile ) {
//     messageDuration = values.singleFile.time;
//   }
//   if ( values.introductionFile ) {
//     messageDuration += values.introductionFile.time;
//   }
//   if ( values.optionsFile ) {
//     messageDuration += values.optionsFile.time;
//   }
//   if ( values.farewellFile ) {
//     messageDuration += values.farewellFile.time;
//   }

//   return Math.ceil(
//     ( numPhones
//       * ( 0.01 * SUCCESS_RATE * ( messageDuration + DELAYS )
//       + 0.01 * ( 100 - SUCCESS_RATE ) * DELAYS )
//     ) / SIMULTANEUS_CALLS,
//   );
// };

const getTime = ( values ) => {
  const {
    CALL_INIT,
    CALL_WRAP_UP,
    MAX_CHANNELS,
    TOTAL_EXTRA_OPTIONS_TIME,
  } = timeCampaignConstants;

  const numPhones = _.filter( values.contacts, { selected: true } ).length;

  let messageDuration = CALL_INIT + CALL_WRAP_UP;

  if ( values.singleFile ) {
    messageDuration += values.singleFile.time;
  }
  if ( values.introductionFile ) {
    messageDuration += values.introductionFile.time;
  }
  if ( values.optionsFile ) {
    messageDuration += (values.optionsFile.time + TOTAL_EXTRA_OPTIONS_TIME);
  }
  if ( values.farewellFile ) {
    messageDuration += values.farewellFile.time;
  }
  let totalDuration = numPhones * messageDuration;
  let totalSecondsAvailable = MAX_CHANNELS * 60;
  let totalPercentage = (totalDuration / totalSecondsAvailable) * 100;

  return Math.ceil((totalPercentage*60)/100);
};

const Footer = ( {
  values, validCost, userCredit, accountFirstPrice, onSubmit, user,
} ) => {
  const [invalidModalOpened, setInvalidModalOpened] = useState( false );
  const [hourToShow, setHourToShow] = useState( {
    start: '', startIntempest: false, end: '', endIntempest: false,
  } );
  const modalTitleRef = useRef( null );

  const toggleInvalidModal = useCallback( ( title ) => {
    modalTitleRef.current = title;
    setInvalidModalOpened( !invalidModalOpened );
  }, [invalidModalOpened] );


  const getCost = useCallback( () => {
    if ( !validCost ) return { usedCredit: 0, cost: 0 };

    const selectedContacts = _.filter( values.contacts, { selected: true } );
    const cost = selectedContacts.length * ( accountFirstPrice + values.ratePriceMinute );
    const usedCredit = userCredit - cost;
    return { usedCredit, cost };
  }, [values.contacts, values.ratePriceMinute, userCredit, accountFirstPrice, validCost] );


  const { usedCredit, cost } = getCost();

  useEffect( () => {
    const setHour = () => {
      if ( values && values.startDate && values.startTime && values.timeZone && validCost ) {
        const getDate = () => {
          const date = `${moment( values.startDate ).format( 'YYYY-MM-DD' )} ${moment( values.startTime ).format( 'HH:mm' )}`;
          if ( moment.tz( date, 'YYYY-MM-DD HH:mm', true, values.timeZone ).diff( moment.tz( values.timeZone ), 'minutes' ) <= 0 ) {
            return moment.tz( values.timeZone );
          }
          return moment.tz( date, 'YYYY-MM-DD HH:mm', true, values.timeZone );
        };
        const start = getDate().format( 'HH:mm' );
        const end = getDate().add( getTime( values ), 'seconds' ).format( 'HH:mm' );


        setHourToShow( {
          start,
          // startIntempest: start >= '21:00' || start < '09:00',
          startIntempest: start >= user.to_time || start < user.from_time,
          end,
          // endIntempest: end >= '21:00' || end < '09:00',
          endIntempest: end >= user.to_time || end < user.from_time,
        } );
      }
    };
    setHour();
    const timer = setInterval( setHour, 4000 );
    return () => {
      clearInterval( timer );
    };
  }, [values, values.contacts, validCost, setHourToShow, user.from_time, user.to_time] );

  return (
    <Row className="mt-5 pt-5">
      <Col md>
        <TextField field="name" placeholder="enterCampaignName" />
      </Col>
      <Col md className="pl-md-0">
        <Button
          color="app-default"
          size="app-sm"
          block
          disabled={!validCost}
          onClick={() => {
            if ( !values.name ) {
              return toggleInvalidModal( <Intl id="campaignNameRequired" /> );
            }
            if ( usedCredit < 0 ) {
              return toggleInvalidModal(
                <Intl
                  id="invalidCampaignCost"
                  values={{ cost: formatNumeral( usedCredit ) }}
                />,
              );
            }
            onSubmit();
          }}
          className="font-weight-700"
        >
          <Intl id="scheduleCampaign" />
          {validCost
          && (
            <>
              {' ( '}
              <span className={classnames( {
                'text-mp-green-1': usedCredit >= 0,
                'text-error': usedCredit < 0,
              } )}
              >
                {numeral( cost ).format( currencyFormat(user.currency_symbol) )}
              </span>
              {' | '}
              <span className={hourToShow.startIntempest ? 'text-danger' : 'text-mp-green-1'}>
                {hourToShow.start}
                {' - '}
              </span>
              <span className={hourToShow.endIntempest ? 'text-danger' : 'text-mp-green-1'}>
                {hourToShow.end}
              </span>
              {' )'}
            </>
          )}
        </Button>
      </Col>

      {invalidModalOpened
      && (
        <ConfirmationModal
          title={modalTitleRef.current}
          translateTitle={false}
          open={invalidModalOpened}
          confirmClose
          onConfirm={toggleInvalidModal}
        />
      )}
    </Row>
  );
};

const mapStateToProps = ( { account, user } ) => ( {
  time: moment().format( 'HH:mm:ss' ),
  userCredit: user.credit || 0,
  accountFirstPrice: account && account.currentPlan ? account.currentPlan.firstPrice : 0,
  user,
} );

export default connect( mapStateToProps )( Footer );
